import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from 'Components/ComponentLibrary/ExternalLibraries/Libraries/MaterialV4/styles';
import fr from 'facet-rest';
import WizardStepWrapperTemplate from 'Views/Page/Content/Templates/WizardTemplates/WizardStepWrapperTemplate';
import metaOverrideSet from 'Views/Page/Content/Templates/WizardTemplates/WizardStepTemplate/MetaOverrideSet';
import Layout
  from 'Views/Page/Content/Templates/WizardTemplates/InvestmentProfileClientUncommonSituationsTemplate/Layout/Layout';

const styles = () => ({
  root: {
    flexDirection: 'column',
    justifyContent: 'center',
  },
});
const InvestmentProfileClientUncommonSituationsTemplate = ({
  className,
  classes,
  resource,
}) => {
  return (
    <WizardStepWrapperTemplate
      className={classNames(className, classes.root)}
      metaOverrideSet={metaOverrideSet}
      resource={resource}
      layout={Layout}
    />
  );
};

InvestmentProfileClientUncommonSituationsTemplate.defaultProps = {
  className: '',
};

InvestmentProfileClientUncommonSituationsTemplate.propTypes = {
  className: PropTypes.string,
  classes: PropTypes.object.isRequired,
  resource: PropTypes.instanceOf(fr.Resource).isRequired,
};

export default withStyles(styles)(InvestmentProfileClientUncommonSituationsTemplate);
